import React from "react";
import { useFormikContext } from "formik";
import styled from "styled-components";

import { HOMEPAGE_V2 } from "@config/testIds/app";

import { Button as ButtonComponent } from "@components/General/Button";

import { text } from "@ui/helpers";
import { TestWrapper } from "@ui/Atoms";

import { useTelemetry } from "@hooks/useTelemetry";

interface Props {
  children: React.ReactNode;
}

export const SubmitButton: React.FC<Props> = props => {
  const { isSubmitting } = useFormikContext();
  const { elementClick } = useTelemetry();

  const clickHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    elementClick(event.currentTarget.textContent || "", {
      buttonId: "service-selector-submit-button",
    });
  };

  return (
    <TestWrapper testId={HOMEPAGE_V2.LETS_GO_BTN}>
      <Button
        type="submit"
        disabled={isSubmitting}
        onClick={clickHandler}
        size="large"
        colorType="green"
        variantStyle="fill"
      >
        <Label>{props.children}</Label>
      </Button>
    </TestWrapper>
  );
};

const Button = styled(ButtonComponent)`
  ${props => props.theme.breakpointsV2.smallTablet} {
    padding-left: ${props => props.theme.spacing.spacing_32};
    padding-right: ${props => props.theme.spacing.spacing_32};
  }

  ${props => props.theme.breakpointsV2.smallDesktop} {
    ${text("semibold_18")}
  }
`;

const Label = styled.span`
  white-space: nowrap;
`;
